export const INITIAL_VALUES = {
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    password: '',
    controlPassword: '',
    checkBoxTermsAndConditions: false,
}
export const MEMBER_INITIAL_VALUES = {
    gender: '',
    date: '',
    residance: '',
    postalCode: '',
    checkBoxMember: false,
    checkBoxRead: false,
}
